import { TFunction } from 'i18next';

// PO says
const getStatusInventoryOptions = (translate: TFunction) => [
  { label: translate('ACTIVE'), value: 'ACTIVE' },
  { label: translate('READY_TO_USE'), value: 'READY_TO_USE' },
  { label: translate('SUSPENDED'), value: 'SUSPENDED' },
  { label: translate('BLOCKED'), value: 'BLOCKED' },
  { label: translate('status:AGR_BLOCKED'), value: 'AGR_BLOCKED' },
];

const getStatusInventoryMoTOptions = (translate: TFunction) => [
  { label: translate('ACTIVE'), value: 'ACTIVE' },
  { label: translate('status:PRE_ACTIVE'), value: 'PRE_ACTIVE' },
  { label: translate('SUSPENDED'), value: 'SUSPENDED' },
  { label: translate('CANCELED'), value: 'CANCELED' },
  { label: translate('status:TRADE_IN'), value: 'TRADE_IN' },
  {
    label: translate('status:WAITING_REACTIVATION'),
    value: 'WAITING_REACTIVATION',
  },
  {
    label: translate('status:WAITING_SUSPENSION'),
    value: 'WAITING_SUSPENSION',
  },
  {
    label: translate('status:WAITING_CANCELLATION'),
    value: 'WAITING_CANCELLATION',
  },
  {
    label: translate('status:WAITING_SUBSTITUTION'),
    value: 'WAITING_SUBSTITUTION',
  },
];

const getStatusOptions = (translate: TFunction) => [
  { label: translate('NEW'), value: 'NEW' },
  { label: translate('READY'), value: 'READY' },
  { label: translate('ACTIVE'), value: 'ACTIVE' },
  { label: translate('DEACTIVATED'), value: 'DEACTIVATED' },
  { label: translate('CANCELED'), value: 'CANCELED' },
  { label: translate('SCHEDULED'), value: 'SCHEDULED' },
  { label: translate('UPDATING'), value: 'UPDATING' },
  { label: translate('BLOCKED'), value: 'BLOCKED' },
  { label: translate('SUSPENDED'), value: 'SUSPENDED' },
  { label: translate('FROZEN'), value: 'FROZEN' },
  { label: translate('MIGRATED'), value: 'MIGRATED' },
  { label: translate('REQUEST_CANCELED'), value: 'REQUEST_CANCELED' },
  { label: translate('PROVISIONING_ERROR'), value: 'PROVISIONING_ERROR' },
  { label: translate('ICCID_NOT_FOUND'), value: 'ICCID_NOT_FOUND' },
  { label: translate('PROVISIONING'), value: 'PROVISIONING' },
  {
    label: translate('PROVISIONING_CONTRACT_ERROR'),
    value: 'PROVISIONING_CONTRACT_ERROR',
  },
  { label: translate('READY_TO_USE'), value: 'READY_TO_USE' },
  {
    label: translate('status:WAITING_SUSPENSION'),
    value: 'WAITING_SUSPENSION',
  },
  {
    label: translate('status:WAITING_REACTIVATION'),
    value: 'WAITING_REACTIVATION',
  },
  { label: translate('status:TRADE_IN'), value: 'TRADE_IN' },
  { label: translate('status:PRE_ACTIVE'), value: 'PRE_ACTIVE' },
  { label: translate('status:AGR_BLOCKED'), value: 'AGR_BLOCKED' },
];

const getBlockingStatusOptions = (translate: TFunction) => [
  {
    label: translate('inventory:lock-status.types.NONE'),
    value: 'NONE',
  },
  {
    label: translate('inventory:lock-status.types.PERMANENT'),
    value: 'PERMANENT',
  },
  {
    label: translate('inventory:lock-status.types.UNTIL_RENEWAL'),
    value: 'UNTIL_RENEWAL',
  },
  {
    label: translate('inventory:lock-status.types.TEMPORARY'),
    value: 'TEMPORARY',
  },
];

const statusEnum = {
  NEW: 'NEW',
  READY: 'READY',
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED',
  CANCELED: 'CANCELED',
  SCHEDULED: 'SCHEDULED',
  UPDATING: 'UPDATING',
  BLOCKED: 'BLOCKED',
  SUSPENDED: 'SUSPENDED',
  FROZEN: 'FROZEN',
  MIGRATED: 'MIGRATED',
  REQUEST_CANCELED: 'REQUEST_CANCELED',
  PROVISIONING_ERROR: 'PROVISIONING_ERROR',
  ICCID_NOT_FOUND: 'ICCID_NOT_FOUND',
  PROVISIONING: 'PROVISIONING',
  PROVISIONING_CONTRACT_ERROR: 'PROVISIONING_CONTRACT_ERROR',
  READY_TO_USE: 'READY_TO_USE',
  STOCK: 'STOCK',
  ALLOCATED: 'ALLOCATED',
};

export {
  getStatusOptions,
  getStatusInventoryOptions,
  getBlockingStatusOptions,
  statusEnum,
  getStatusInventoryMoTOptions,
};
